import React, { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import Button from 'layout/atoms/Button/Button';
import TabsButton from 'layout/atoms/TabsButton/TabsButton';
import Grid from 'layout/molecules/Grid/Grid';
import { openModal } from 'store/layoutSlice';
import Countries from '../Countries/Countries';
import productParameterConfigs from './config';
import ProductParameterTable from './ProductParameterTable';
import styles from './ProductParameterTable.module.scss';
function ProductParameters() {
    const dispatch = useDispatch();
    const { t } = useTranslation(['specification', 'common']);
    const [mode, setMode] = useState('functions');
    const configTabs = Object.values(productParameterConfigs).map((item) => ({
        id: item.mode,
        label: t(item.labelKey),
    }));
    const continentsIndex = configTabs.findIndex((tab) => tab.id === 'continents');
    const tabs = [
        ...configTabs.slice(0, continentsIndex + 1),
        { id: 'countries', label: t('countries') },
        ...configTabs.slice(continentsIndex + 1),
    ];
    const tabsButton = (React.createElement(TabsButton, { size: "s", activeTab: mode, tabs: tabs, onClick: (id) => setMode(id) }));
    if (mode === 'countries') {
        return (React.createElement(Grid, { gap: 24 },
            React.createElement("div", { className: styles.toolbar }, tabsButton),
            React.createElement(Countries, null)));
    }
    const config = productParameterConfigs[mode];
    const toolbar = (React.createElement(React.Fragment, null,
        tabsButton,
        React.createElement(Button, { color: "primary", onClick: () => dispatch(openModal({ name: config.creatorModalName })) }, t(config.addLabelKey))));
    return React.createElement(ProductParameterTable, { key: mode, config: config, toolbar: toolbar });
}
export default memo(ProductParameters);
